import React, { Component } from "react";
import DesignSettings from "../../components/settings/DesignSettings";
import DeleteDialog from "../../components/DeleteDialog";
import { languages } from "../../constants/languages";
import UpgradeDialog from "../../components/UpgradeDialog";
import { generateSearchRecords } from "../../util/GenerateSearchRecords";
import { getUploadErrorMessage } from "../../util/uploadErrors";

class DesignSettingsContainer extends Component {
  state = {
    isUploading: false,
    uploadingType: "",
    uploadingSponsorIndex: undefined,
    uploadingSponsorGroup: undefined,
    errorMessageLogo: "",
    errorMessageBG: "",
    errorMessageSponsors: {},
    sponsorIndex: undefined,
    sponsorGroup: undefined,
    openDeleteDialog: false,
    upgradeDialogOpen: false,
    openSponsorLinkDialog: false,

    colorLockMessage: "", // PSD

    sponsorsTemp: undefined,
    sponsorLinksTemp: undefined,

    warningSVG: {
      type: "",
      sponsorGroup: undefined,
      sponsorIndex: undefined,
    },
  };

  handleColorLock = () => {
    this.setState({ colorLockMessage: languages.tournament.colorLockMessage });
  };

  toggleUpgradeDialog = () => {
    if (!this.state.upgradeDialogOpen) {
      if (window.firebase.analytics) {
        window.firebase.analytics().logEvent("paywall_design_page");
      }
      // mailer lite paywall seen
      window.firebase
        .firestore()
        .collection("paywallSeenRequests")
        .doc()
        .set({ uid: this.props.user.uid });
    }
    this.setState({ upgradeDialogOpen: !this.state.upgradeDialogOpen });
  };

  handleUploadStart = (
    uploadType,
    sponsorIndex = undefined,
    sponsorGroup = undefined
  ) => {
    this.setState({
      isUploading: true,
      uploadingType: uploadType || "",
      uploadingSponsorIndex: sponsorIndex,
      uploadingSponsorGroup: sponsorGroup,
      errorMessageLogo: "",
      errorMessageBG: "",
      errorMessageSponsors: {},
    });
  };

  handleProgress = (progress) => {
    this.setState({ progress });
  };

  handleUploadError = (
    error,
    uploadType,
    sponsorIndex = undefined,
    blockNum = undefined
  ) => {
    this.setState({
      isUploading: false,
      uploadingType: "",
      uploadingSponsorIndex: undefined,
      uploadingSponsorGroup: undefined,
    });
    const maxSizeInMbByUploadType = {
      logos: 1,
      backgrounds: 3,
      sponsors: 1,
    };
    const errorMessage = getUploadErrorMessage(
      error,
      maxSizeInMbByUploadType[uploadType]
    );
    let toUpdate = {};
    if (uploadType === "logos") {
      toUpdate = { errorMessageLogo: errorMessage };
    }
    if (uploadType === "backgrounds") {
      toUpdate = { errorMessageBG: errorMessage };
    }
    if (uploadType === "sponsors") {
      let sponsorErrors = {};
      // sponsorErrors[
      //   sponsorIndex || (this.props.tournament.sponsors || []).length
      // ] = error.message;
      sponsorErrors = {
        blockNum: blockNum,
        sponsorIndex: sponsorIndex,
        message: errorMessage,
      };
      toUpdate = { errorMessageSponsors: sponsorErrors };
    }
    this.setState(toUpdate);
  };

  handleUploadSuccess = (
    filename,
    uploadType,
    sponsorIndex = undefined,
    sponsorGroup = undefined
  ) => {
    this.setState({
      isUploading: false,
      uploadingType: "",
      uploadingSponsorIndex: undefined,
      uploadingSponsorGroup: undefined,
    });
    const storageRef = this.getStorageRef(uploadType);
    storageRef
      .child(filename)
      .getDownloadURL()
      .then((url) => {
        storageRef
          .child(filename)
          .getMetadata()
          .then((metadata) => {
            if (metadata.contentType === "image/svg+xml") {
              this.setState({
                warningSVG: {
                  type: uploadType,
                  sponsorGroup: sponsorGroup,
                  sponsorIndex: sponsorIndex,
                },
              });
            } else {
              this.setState({
                warningSVG: {
                  type: "",
                  sponsorGroup: undefined,
                  sponsorIndex: undefined,
                },
              });
            }
            let toUpdate = {};
            if (uploadType === "logos") {
              toUpdate = { logoURL: url };
            }
            if (uploadType === "backgrounds") {
              toUpdate = { bgURL: url };
            }
            if (uploadType === "sponsors") {
              let sponsors =
                this.props.tournament[
                  "sponsors" +
                    (sponsorGroup !== undefined ? sponsorGroup.toString() : "")
                ] || [];
              if (sponsorIndex !== undefined) {
                sponsors[sponsorIndex] = url;
              } else {
                sponsors.push(url);
              }
              toUpdate[
                "sponsors" +
                  (sponsorGroup !== undefined ? sponsorGroup.toString() : "")
              ] = sponsors;
            }
            const db = window.firebase.firestore();
            let batch = db.batch();

            batch.update(
              window.firebase
                .firestore()
                .collection("tournaments")
                .doc(this.props.tournament[".key"]),
              toUpdate
            );
            if (this.props.tournament.ia) {
              batch = generateSearchRecords(
                {
                  id: this.props.tournament[".key"],
                  name: this.props.tournament.name,
                  date: this.props.tournament.date,
                  bgURL:
                    uploadType === "backgrounds"
                      ? url
                      : this.props.tournament.bgURL,
                  logoURL:
                    uploadType === "logos"
                      ? url
                      : this.props.tournament.logoURL,
                },
                batch
              );
            }
            batch.commit();
          });
      });
  };

  toggleDeleteDialog = (
    uploadType,
    sponsorIndex = undefined,
    sponsorGroup = undefined
  ) => {
    if (uploadType === "logos") {
      this.setState({ openDeleteDialog: "logos" });
    } else if (uploadType === "backgrounds") {
      this.setState({ openDeleteDialog: "backgrounds" });
    } else if (uploadType === "sponsors") {
      this.setState({
        openDeleteDialog: "sponsors",
        sponsorIndex: sponsorIndex,
        sponsorGroup: sponsorGroup,
      });
    } else {
      this.setState({ openDeleteDialog: false });
    }
  };

  toggleSponsorLinkDialog = (
    e,
    sponsorIndex = undefined,
    sponsorGroup = undefined
  ) => {
    if (sponsorIndex !== undefined) {
      this.setState({
        openSponsorLinkDialog: sponsorIndex,
        sponsorGroup: sponsorGroup,
      });
    } else {
      this.setState({ openSponsorLinkDialog: false });
    }
  };

  handleDelete = (uploadType) => {
    this.toggleDeleteDialog(false);
    let toUpdate = {};
    // let urlToDelete = "";
    if (uploadType === "logos") {
      toUpdate = { logoURL: null };
      // urlToDelete = this.props.tournament.logoURL;
    }
    if (uploadType === "backgrounds") {
      toUpdate = { bgURL: null };
      // urlToDelete = this.props.tournament.bgURL;
    }
    if (uploadType === "sponsors") {
      let sponsors =
        this.props.tournament[
          "sponsors" +
            (this.state.sponsorGroup !== undefined
              ? this.state.sponsorGroup.toString()
              : "")
        ];
      let sponsorLinks =
        this.props.tournament[
          "sponsorLinks" +
            (this.state.sponsorGroup !== undefined
              ? this.state.sponsorGroup.toString()
              : "")
        ] || [];
      sponsors.splice(this.state.sponsorIndex, 1);
      sponsorLinks.splice(this.state.sponsorIndex, 1);
      toUpdate[
        "sponsors" +
          (this.state.sponsorGroup !== undefined
            ? this.state.sponsorGroup.toString()
            : "")
      ] = sponsors;
      toUpdate[
        "sponsorLinks" +
          (this.state.sponsorGroup !== undefined
            ? this.state.sponsorGroup.toString()
            : "")
      ] = sponsorLinks;
    }

    const db = window.firebase.firestore();
    let batch = db.batch();

    batch.update(
      window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"]),
      toUpdate
    );
    if (this.props.tournament.ia) {
      batch = generateSearchRecords(
        {
          id: this.props.tournament[".key"],
          name: this.props.tournament.name,
          date: this.props.tournament.date,
          bgURL:
            uploadType === "backgrounds" ? null : this.props.tournament.bgURL,
          logoURL:
            uploadType === "logos" ? null : this.props.tournament.logoURL,
        },
        batch
      );
    }
    batch.commit();
    // var httpsReference = window.firebase
    //   .app()
    //   .storage("gs://tournament-uploads/")
    //   .refFromURL(urlToDelete);
    // httpsReference.delete().catch(function (error) {
    //   // Uh-oh, an error occurred!
    //   console.log(error.message);
    // });
  };

  getStorageRef = (uploadType) => {
    return window.firebase
      .app()
      .storage("gs://tournament-uploads/")
      .ref(
        uploadType +
          "/" +
          this.props.user.uid +
          "/" +
          this.props.tournament[".key"]
      );
  };

  handleChangeComplete = (color) => {
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update({ color: color.hex });
  };

  onDragEndBlock = (result) => {
    if (!result.destination) {
      return;
    }
    let allSponsors = [[this.props.tournament.sponsors || [], 0]];

    let allSponsorLinks = [this.props.tournament.sponsorLinks || []];

    for (let i = 1; i < 100; i++) {
      if (
        this.props.tournament["sponsors" + i.toString()] &&
        (this.props.tournament["sponsors" + i.toString()] || []).length > 0
      ) {
        allSponsors.push([this.props.tournament["sponsors" + i.toString()], i]);
        allSponsorLinks.push(
          this.props.tournament["sponsorLinks" + i.toString()] || []
        );
      }
    }

    let sponsorBlockOrder = allSponsors.map((s, i) => s[1]);
    sponsorBlockOrder.sort((a, b) => {
      let indexA =
        (this.props.tournament.sponsorBlockOrder || []).indexOf(a) !== -1
          ? (this.props.tournament.sponsorBlockOrder || []).indexOf(a)
          : 9999;
      let indexB =
        (this.props.tournament.sponsorBlockOrder || []).indexOf(b) !== -1
          ? (this.props.tournament.sponsorBlockOrder || []).indexOf(b)
          : 9999;
      return indexA - indexB;
    });

    // console.log(
    //   result.source.index,
    //   result.destination.index,
    //   sponsorBlockOrder
    // );

    const [removed] = sponsorBlockOrder.splice(result.source.index, 1);
    sponsorBlockOrder.splice(result.destination.index, 0, removed);
    // const [removedLink] = allSponsorLinks.splice(result.source.index, 1);
    // allSponsorLinks.splice(result.destination.index, 0, removedLink);

    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    // let newSponsors = {};
    // allSponsors.forEach((l, i) => {
    //   newSponsors["sponsors" + (i === 0 ? "" : i.toString())] = l;
    //   newSponsors["sponsorLinks" + (i === 0 ? "" : i.toString())] =
    //     allSponsorLinks[i];
    // });
    this.setState({
      sponsorBlockOrderTemp: sponsorBlockOrder,
      // sponsorLinksTemp: allSponsorLinks,
    });
    tournamentRef
      .update({ sponsorBlockOrder: sponsorBlockOrder })
      .catch((error) => {
        console.log(error.message);
        this.setState({
          sponsorBlockOrderTemp: undefined,
          sponsorLinksTemp: undefined,
        });
      })
      .then(() => {
        this.setState({
          sponsorBlockOrderTemp: undefined,
          sponsorLinksTemp: undefined,
        });
      });
  };

  render() {
    let deleteTitle = "";
    let deleteDescription = "";
    if (this.state.openDeleteDialog === "logos") {
      deleteTitle = languages.tournament.deleteLogo;
      deleteDescription = languages.tournament.deleteLogoWarning;
    } else if (this.state.openDeleteDialog === "backgrounds") {
      deleteTitle = languages.tournament.deleteBG;
      deleteDescription = languages.tournament.deleteBGWarning;
    } else if (this.state.openDeleteDialog === "sponsors") {
      deleteTitle = languages.tournament.deleteSponsor;
      deleteDescription = languages.tournament.deleteSponsorWarning;
    }

    let allowedToUpload = false;
    if (
      this.props.tournamentStatus.status === 1 ||
      this.props.tournamentStatus.status === 2 ||
      this.props.tournamentStatus.status === 3 ||
      this.props.userStatus.status === 1 ||
      this.props.userStatus.status === 2 ||
      this.props.userStatus.status === 3
    ) {
      allowedToUpload = true;
    }

    let allSponsors = [[this.props.tournament.sponsors || [], 0]];
    let lastSponsor = 0;
    for (let i = 1; i < 100; i++) {
      if (
        this.props.tournament["sponsors" + i.toString()] &&
        (this.props.tournament["sponsors" + i.toString()] || []).length > 0
      ) {
        lastSponsor = i;
        allSponsors.push([this.props.tournament["sponsors" + i.toString()], i]);
      }
    }

    let sponsorOrder =
      this.state.sponsorBlockOrderTemp ||
      this.props.tournament.sponsorBlockOrder ||
      allSponsors.map((s, i) => i);
    allSponsors.sort((a, b) => {
      let indexA =
        sponsorOrder.indexOf(a[1]) !== -1 ? sponsorOrder.indexOf(a[1]) : 9999;
      let indexB =
        sponsorOrder.indexOf(b[1]) !== -1 ? sponsorOrder.indexOf(b[1]) : 9999;
      return indexA - indexB;
    });

    return (
      <div>
        <DeleteDialog
          open={this.state.openDeleteDialog ? true : false}
          uploadType={this.state.openDeleteDialog}
          toggleDialog={this.toggleDeleteDialog}
          handleDelete={() => this.handleDelete(this.state.openDeleteDialog)}
          title={deleteTitle}
          description={deleteDescription}
        />
        <DesignSettings
          tournament={this.props.tournament}
          logoStorageRef={this.getStorageRef("logos")}
          backgroundStorageRef={this.getStorageRef("backgrounds")}
          sponsorStorageRef={this.getStorageRef("sponsors")}
          handleUploadStart={this.handleUploadStart}
          handleProgress={this.handleProgress}
          handleUploadError={this.handleUploadError}
          handleUploadSuccess={this.handleUploadSuccess}
          errorMessageLogo={this.state.errorMessageLogo}
          errorMessageBG={this.state.errorMessageBG}
          errorMessageSponsors={this.state.errorMessageSponsors}
          toggleDeleteDialog={this.toggleDeleteDialog}
          handleChangeComplete={this.handleChangeComplete}
          allowedToUpload={allowedToUpload}
          toggleUpgradeDialog={this.toggleUpgradeDialog}
          allSponsors={allSponsors}
          lastSponsor={lastSponsor}
          toggleSponsorLinkDialog={this.toggleSponsorLinkDialog}
          openSponsorLinkDialog={this.state.openSponsorLinkDialog}
          sponsorGroup={this.state.sponsorGroup}
          handleColorLock={this.handleColorLock}
          colorLockMessage={this.state.colorLockMessage}
          onDragEndBlock={this.onDragEndBlock}
          // sponsorsTemp={this.state.sponsorsTemp}
          // sponsorLinksTemp={this.state.sponsorLinksTemp}
          warningSVG={this.state.warningSVG}
          isUploading={this.state.isUploading}
          uploadingType={this.state.uploadingType}
          uploadingSponsorIndex={this.state.uploadingSponsorIndex}
          uploadingSponsorGroup={this.state.uploadingSponsorGroup}
        />
        <UpgradeDialog
          open={this.state.upgradeDialogOpen}
          toggleDialog={this.toggleUpgradeDialog}
          title={languages.upgrade.upgradeTournament}
          description={languages.upgrade.upgradeText1}
          tournament={this.props.tournament}
          user={this.props.user}
          userData={this.props.userData}
          tournamentStatus={this.props.tournamentStatus}
        />
      </div>
    );
  }
}

export default DesignSettingsContainer;
